import React from "react";
import { useNavigate } from "react-router-dom";
import { WarningTriangleIcon, DownloadIcon } from "../icons/exportIcons";

/**
 * MOCK DATA — Clinic Offboarding Phase 1's clinic.status / notice_sent_at
 * fields aren't merged on this branch yet. This banner is wired for visual
 * QA now; swap MOCK_CLOSURE_DATE for the real clinic notice date once
 * Phase 1 lands, and gate rendering on notice_sent_at being set.
 */
const MOCK_CLOSURE_DATE = new Date("2026-08-31T23:59:00+05:30");

function daysUntil(date: Date): number {
  return Math.max(0, Math.ceil((date.getTime() - Date.now()) / (1000 * 60 * 60 * 24)));
}

export const ClinicClosureBanner: React.FC = () => {
  const navigate = useNavigate();
  const days = daysUntil(MOCK_CLOSURE_DATE);
  const dateLabel = MOCK_CLOSURE_DATE.toLocaleDateString("en-IN", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });

  return (
    <div className="flex flex-wrap items-center justify-between gap-4 rounded-xl border border-amber-200 bg-amber-50 px-5 py-4 mb-5">
      <div className="flex items-start gap-3">
        <WarningTriangleIcon className="text-amber-600 flex-shrink-0 mt-0.5" />
        <div>
          <p className="text-sm font-semibold text-amber-800">
            Clinic closure scheduled for {dateLabel} — {days} days left
          </p>
          <p className="text-sm text-amber-700 mt-0.5">
            Access to Kaagazy ends at 11:59 PM IST that day. Download a full copy of your
            clinic&apos;s data before then.
          </p>
        </div>
      </div>
      <div className="flex items-center gap-3 flex-shrink-0">
        <button
          className="rounded-lg border border-amber-300 bg-white px-4 py-2 text-sm font-medium text-amber-800 hover:bg-amber-100"
          onClick={() => navigate("/settings?section=clinic")}
        >
          Review Closure Details
        </button>
        <button
          className="inline-flex items-center gap-2 rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700"
          onClick={() => navigate("/settings?section=privacy")}
        >
          <DownloadIcon /> Download Clinic Data
        </button>
      </div>
    </div>
  );
};
